import { GET_COURSE_FROM_REGION_AND_ITALY } from 'redux/action-types/courses'

export const getCourseFromRegionAndItaly = () => ({
  type: GET_COURSE_FROM_REGION_AND_ITALY
})
